import axiosPrivate from "../../../api/axiosPrivate";
import {
  ACTIVATE_ROLE,
  ACTIVE_ROLES_URL,
  CREATE_ROLE,
  DEACTIVATE_ROLE,
  GET_ALL_ROLES,
  GET_SINGLE_ROLE,
  SEARCH_ROLE,
  UPDATE_ROLE,
} from "../../../api/constant";

// Create new role
const createRole = async (roleData) => {
  const response = await axiosPrivate.post(CREATE_ROLE, roleData);
  return response.data;
};

// // Fetch all roles
const getAllRoles = async (pageNumber) => {
  const response = await axiosPrivate.get(
    `${GET_ALL_ROLES}?page=${pageNumber}`
  );
  return response.data;
};

// Fetch single role
const getSingleRole = async (id) => {
  const response = await axiosPrivate.get(`${GET_SINGLE_ROLE}/${id}`);
  return response.data;
};
// Update role
const updateRole = async (formData) => {
  const response = await axiosPrivate.post(
    `${UPDATE_ROLE}/${formData.id}`,
    formData
  );
  return response.data;
};

// deactivate role
const deactivateRole = async (role_id) => {
  const response = await axiosPrivate.get(`${DEACTIVATE_ROLE}/${role_id}`);
  return response.data;
};

// activate role
const activateRole = async (role_id) => {
  const response = await axiosPrivate.get(`${ACTIVATE_ROLE}/${role_id}`);
  return response.data;
};

// Fetch all active roles
const getAllActiveRoles = async () => {
  const response = await axiosPrivate.get(ACTIVE_ROLES_URL);
  return response.data;
};

//search user
const searchRoles = async (searchText) => {
  const response = await axiosPrivate.get(
    `${SEARCH_ROLE}?&search=${searchText}`
  );
  return response.data;
};

const roleService = {
  createRole,
  getAllRoles,
  getSingleRole,
  updateRole,
  activateRole,
  deactivateRole,
  getAllActiveRoles,
  searchRoles,
};

export default roleService;
